import { actionTypes }  from '../actions'
import { adjustedTimerState } from '../utils/timer-adjustment';


const initialState = {
      startedAt: undefined,
      stoppedAt: undefined,
      baseTime: undefined
}

export default function (state=initialState, action) {
  switch (action.type) {
      case actionTypes.SET_TIMER_ELAPSED:
        return adjustedTimerState(state, action.elapsedMs, action.now) || state;
  	case actionTypes.RESET_TIMER:
        return {	
          ...state,
          baseTime: 0,
          startedAt: undefined,
          stoppedAt: undefined
        };
      case actionTypes.START_TIMER:
        return {      
          ...state,    
          baseTime: action.baseTime,
          startedAt: action.now,
          stoppedAt: undefined
        };
      case actionTypes.STOP_TIMER:
        return {
          ...state,
          stoppedAt: action.now
        }
      default:
        return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reducer-timer.js